import React from 'react';
import styled from 'styled-components';

const Title = styled.p`
    font-size: 0.9rem;
    margin-bottom: 0rem;
    color: grey;
`;

const Category = styled.p`
    font-size: .7rem;
    margin-bottom: 0rem;
    color: grey;
`;

const MenuItemCell = (props) => {
    return (
        <div>
            <Title>{props.item.title}</Title>
            <Category>{props.item.category.join(' > ')}</Category>
        </div>
    )
};

export default MenuItemCell



// WEBPACK FOOTER //
// ./src/components/Search/MenuItemCell.js